export default "__VITE_ASSET__CDOrEbf3__"